'use client';

import { datadogRum } from '@datadog/browser-rum';
import { type ReactNode, useEffect, useRef } from 'react';

type SummaryTableDatadogTimingProps = {
  children: ReactNode;
};

/**
 * Client component wrapper that fires Datadog timing when actual table content
 * (not skeleton) is mounted and visible.
 */
export function SummaryTableDatadogTiming({ children }: SummaryTableDatadogTimingProps) {
  const firedSummaryTableShown = useRef(false);

  useEffect(() => {
    // Fire timing on mount - this means the actual content (not skeleton) is now visible
    if (!firedSummaryTableShown.current) {
      datadogRum.addTiming('summary_table_shown');
      firedSummaryTableShown.current = true;
    }
  }, []);

  return <>{children}</>;
}
